export const FILTER = {
    BRAND_NAME: 'brand_name',
    INDUSTRY: 'industry',
    LOGO_ELEMENTS: 'logo_elements',
};

export const MPI_INDUSTRIES_FILTER_MAX_TAGS = 3;

export const MPI_INDUSTRIES_FILTER_STORAGE_KEY =
    'mpi_industry_filter_industries';

export const TOOLTIP_STORAGE_KEY = 'logo_maker_listings_education_tooltip';

export const BRAND_NAME_PROP = 'brandName';

export const SLOGAN_PROP = 'slogan';
